<template>
  <div class="calendar">
    <v-container grid-list-md text-xs-center class="c-main-shadow swipe">
      <tab-year-month
        v-if="yyyymm != -1"
        ref="ymTab"
        id="calendar-ym"
        :cid="id"
        :yyyymm="yyyymm"
        :createNewTitle="$T('button.add')"
        :slots="slots"
        :useNodate="false"
        @add="openRegisterDialog"
        @prepareSlot="prepareSlot"
        @prepareSubSlot="prepareSubSlot"
        @removeSlots="removeSlots"
        @saveHistory="saveHistory"
        @inview="onInview"
      >
        <template v-for="(s, idx) in slots" :slot="s.idx">
          <div v-if="s.destroy"></div>
          <calendar-month
            v-else
            :ref="`m-${s.ym}`"
            :inview="s.inview"
            :error="s.error"
            :data="s.data"
            :ym="s.ym"
          ></calendar-month>
        </template>
      </tab-year-month>

      <spinner v-else></spinner>
    </v-container>

    <edit-event-dialog
      v-if="editDialog"
      :calEvent="editData.calEvent"
      :members="editData.members"
      :targetMoment="editData.targetMoment"
      @close="editDialog = false"
    ></edit-event-dialog>
  </div>
</template>

<script>
import { CONST } from '../../constant';
import UTILS from '../../utils/utils';
import eventList from './EventList.vue';
import { fetchEvent } from '../../api/communityEvent';
import tabYearMonth from '../common/TabYearMonth.vue';
import calendarMonthComponent from './CalendarMonthComponent.vue';
import editEventDialog from '../event/EditEventDialog.vue';

export default {
  beforeRouteEnter(route, redirect, next) {
    console.log('enter history');
    next(vm => vm.updateHistory());
  },
  beforeRouteUpdate(to, from, next) {
    this.id = Number(to.params.id);
    next();
  },
  components: {
    'tab-year-month': tabYearMonth,
    'calendar-month': calendarMonthComponent,
    'edit-event-dialog': editEventDialog,
  },
  mounted: function() {
    this.$store.commit('CAL_CLEAR_EDITS');
    var self = this;
    window.addEventListener('popstate', this.onPopstate);
  },
  beforeDestroy: function() {
    window.removeEventListener('popstate', this.onPopstate);
  },
  computed: {
    stateRegisteredEvents() {
      return this.$store.state.calendar.registeredEvents;
    },
    stateUpdatedEvents() {
      return this.$store.state.calendar.updatedEvents;
    },
    stateDeletedEvents() {
      return this.$store.state.calendar.deletedEvents;
    },
    stateCalRegister() {
      return this.$store.state.calendar.register;
    },
    stateCalUpdate() {
      return this.$store.state.calendar.update;
    },
    ym() {
      return this.$refs.ymTab.current;
    },
  },
  watch: {
    stateRegisteredEvents(n, o) {
      if (!n.length) return (this.nextRegisteredIdx = 0);
      for (var i = this.nextRegisteredIdx; i < n.length; i++) {
        var data = n[i];
        var item = data.item;
        var ft = this.toFromTo(item);
        this.appendItemToCache(item.community_id, item, ft);
        this.appendItemToCache(0, item, ft);
      }
      this.nextRegisteredIdx = n.length;
      this.$refs.ymTab.adjustHeightRestart(100);
    },
    stateUpdatedEvents(n, o) {
      if (!n.length) return (this.nextUpdatedDateIdx = 0);
      for (var i = this.nextUpdatedDateIdx; i < n.length; i++) {
        var data = n[i];
        var old = data.old;
        var item = data.item;
        // use use timezone, no use item timezone.
        var ftOld = this.toFromTo(old);
        var ft = this.toFromTo(item);
        this.removeItemFromCache(old.community_id, old, ftOld);
        this.removeItemFromCache(0, old, ftOld);
        this.appendItemToCache(item.community_id, item, ft);
        this.appendItemToCache(0, item, ft);
      }
      this.nextUpdatedDateIdx = n.length;
      this.$refs.ymTab.adjustHeightRestart(100);
    },
    stateDeletedEvents(n, o) {
      if (!n.length) return (this.nextDeletedIdx = 0);
      for (var i = this.nextDeletedIdx; i < n.length; i++) {
        var data = n[i];
        var item = data.item;
        var ft = this.toFromTo(item);
        this.removeItemFromCache(item.community_id, item, ft);
        this.removeItemFromCache(0, item, ft);
      }
      this.nextDeletedIdx = n.length;
      this.$refs.ymTab.adjustHeightRestart(100);
    },
    stateCalRegister(n, o) {
      if (!n) return;
      this.openRegisterDialog(n);
      this.$nextTick(function() {
        this.$store.commit('CAL_REGISTER', null);
      });
    },
    stateCalUpdate(n, o) {
      if (!n) return;
      this.openEditDialog(n);
      this.$nextTick(function() {
        this.$store.commit('CAL_UPDATE', null);
      });
    },
  },
  data() {
    return {
      id: Number(this.$route.params.id),
      yyyymm: this.initYyyyMm(),
      slots: [],
      cache: {},
      nextRegisteredIdx: 0,
      nextUpdatedDateIdx: 0,
      nextRegisteredIdx: 0,
      currentYm: Number(this.$moment().format('YYYYMM')),
      editData: {
        calEvent: null,
        targetMoment: null,
      },
      editDialog: false,
    };
  },
  methods: {
    toFromTo(item) {
      var s = Number.isInteger(item.start)
        ? this.$moment.unix(item.start)
        : this.$moment(item.start, 'YYYY-MM-DD HH:mm:ss');
      var e = Number.isInteger(item.end) ? this.$moment.unix(item.end) : this.$moment(item.end, 'YYYY-MM-DD HH:mm:ss');
      return [Number(s.add(-1, 'M').format('YYYYMM')), Number(e.add(1, 'M').format('YYYYMM'))];
    },
    removeItemFromCache(cid, item, fromTo) {
      var from = fromTo[0];
      var to = fromTo[1];
      var ym = from;
      while (ym <= to) {
        var items = this.cache[this.localCacheKey(cid, ym)];
        if (!items) {
          this.$utils.toYyyyMm(++ym);
          continue;
        }

        for (var idx = 0; idx < items.length; idx++) {
          if (item.id == items[idx].id) {
            items.splice(idx, 1);
            this.$commin.clientdb.putObject(this.clientDbKey(cid, ym), items);
            break;
          }
        }
        this.$utils.toYyyyMm(++ym);
      }
    },
    appendItemToCache(cid, item, fromTo) {
      var from = fromTo[0];
      var to = fromTo[1];
      var ym = from;
      while (ym <= to) {
        var items = this.cache[this.localCacheKey(cid, ym)];
        if (!items) {
          this.$utils.toYyyyMm(++ym);
          continue;
        }
        console.log(`append item to ym=${ym}`);
        items.push(item);
        this.$commin.clientdb.putObject(this.clientDbKey(cid, ym), items);
        this.$utils.toYyyyMm(++ym);
      }
    },
    initYyyyMm() {
      var v = this.calcYyyyMm(this.$route.params.t ? this.$route.params.t : this.loadYm(this.currentYm));
      return v ? v : Number(this.$moment().format('YYYYMM'));
    },
    calcYyyyMm(t) {
      if (!t) return Number(this.currentYm);
      if (t == 'n') return Number(this.currentYm);
      t = Number(t);
      return t > CONST.tab_ym.limit.max || t < CONST.tab_ym.limit.min ? Number(this.currentYm) : t;
    },
    onPopstate(e) {
      if (!e.state) return;
      var data = null;
      try {
        data = JSON.parse(e.state);
      } catch (ex) {
        console.log('failed to parse history, but ok. this will be change community.');
        return;
      }
      if (data.page != 'calendar') return;
      this.saveYm(data.ym);
      this.setTitle(data.ym, data.id);
      if (this.id != data.id) {
        this.id = Number(data.id);
        this.$refs.ymTab.refreshData(data.ym);
      } else {
        this.$refs.ymTab.historyBack(data.ym);
      }
      console.log(`history back to ${data.ym}`);
    },
    saveHistory(ym, force) {
      // if (!force && this.isRouteForViewer()) return;
      console.log(`save history to ${ym} id=${this.id}`);
      this.saveYm(ym);
      this.setTitle(ym);
      var path = `/calendar/${this.id}/${ym || 'n'}`;
      if (this.isGuest) path += `/${window.$L}/guest`;
      this.$store.commit('PATH', path);
      history.pushState(JSON.stringify({ page: 'calendar', id: this.id, ym: ym }), document.title, path);
      this.$ga?.page(path); // GA は prod ホストのみ install（main.js）。非 prod では $ga 不在のため optional chaining で no-op
    },
    updateHistory() {
      var ym = this.initYyyyMm();
      if (ym) console.log(`update history to ${ym} id=${this.id} href=${location.href}`);
      this.setTitle(ym);
      history.replaceState(JSON.stringify({ page: 'calendar', id: this.id, ym: ym }), document.title, location.href);
    },
    setTitle(ym) {
      this.$utils.setDocumentTitleWithFreeWord(`CALENDAR ${ym}`, this.id);
    },
    prepareSlot(ym, idx) {
      console.log(`prepare for ${ym} id=${this.id}`);
      this.prepare(ym, idx, true, this.getData(idx, ym, true));
    },
    prepareSubSlot(ym, idx, current) {
      this.prepare(ym, idx, false, this.getData(idx, ym, false));
    },
    prepare(ym, idx, inview, data) {
      this.slots.push({
        idx: idx,
        ym: ym,
        inview: inview,
        error: false,
        destroy: false,
        data: data,
      });
    },
    removeSlots(idxes) {
      var c = 0;
      for (var i = this.slots.length - 1; i >= 0; i--) {
        var idx = idxes.indexOf(this.slots[i].idx);
        if (idx != -1) {
          this.slots[i].destroy = true;
          this.slots[i].data.d = null;
          if (idxes.length == 1) break;
          idxes.splice(idx, 1);
        }
      }
    },
    onInview(idx) {
      var slot = this.getSlot(idx);
      slot.inview = true;
    },
    getData(idx, ym, wide) {
      var id = this.id;
      var key = this.localCacheKey(id, ym);
      var d = this.cache[key];

      // if there is in temp cache, don't access to server.
      if (d) {
        console.log(`use local cache for ${ym}`);
        return { s: 'cache', d: d };
      }

      this.getDataFromCliendDb(idx, id, ym);
      this.getDataFromServer(idx, id, ym, wide);

      return { s: 'preparing', d: d };
    },
    getDataFromCliendDb(idx, id, ym) {
      var self = this;
      this.$commin.clientdb.getObject(this.clientDbKey(id, ym), function(data) {
        if (data) {
          console.log(`got data from client db id${id} ym${ym}`);
          self.setData(idx, id, ym, data, false, true);
        }
      });
    },
    getDataFromServer(idx, id, ym, wide) {
      var self = this;
      fetchEvent(id, ym, wide)
        .then(function(response) {
          for (var key in response) {
            var resultYm = Number(key.substring(1));
            var events = response[key].map(event => {
              let newEvent = { ...event };
              newEvent.start = self.$moment(event.start * 1000).format('YYYY-MM-DD HH:mm:ss');
              newEvent.end = self.$moment(event.end * 1000).format('YYYY-MM-DD HH:mm:ss');
              return newEvent;
            });
            self.setData(idx, id, resultYm, events, true, resultYm == ym);
          }
        })
        .catch(function(error) {
          console.error('failed to get calendar data', error);
          self.setError(idx, ym);
        });
    },
    setData(idx, id, ym, data, serverData, setSlot) {
      if (serverData) {
        if (setSlot) {
          this.getSlot(idx).data = { s: 'done', d: data };
        }
        this.cache[this.localCacheKey(id, ym)] = data;
        this.$commin.clientdb.putObject(this.clientDbKey(id, ym), data);
      } else if (setSlot) {
        var slot = this.getSlot(idx);
        if (slot.data.s != 'done') {
          slot.data = { s: 'clientdb', d: data };
        }
      }
    },
    setError(idx, ym) {
      var slot = this.getSlot(idx);
      slot.error = true;
    },
    getSlot(idx) {
      for (var i = this.slots.length - 1; i >= 0; i--) {
        if (this.slots[i].idx == idx) {
          return this.slots[i];
        }
      }
    },
    localCacheKey(id, ym) {
      return `d-${id}-${ym}`;
    },
    clientDbKey(id, ym) {
      return `calendar-${id}-${ym}`;
    },
    openRegisterDialog(d) {
      if (this.isGuest) return this.shortMsg($T('common.guest_not_allowed'));
      var s = null;
      if (!d) {
        var calYm = this.$refs[`m-${this.ym}`];
        if (calYm && calYm.length == 1 && calYm[0].currentDate) {
          d = calYm[0].currentDate;
        }
      }

      this.editData = {
        calEvent: null,
        targetMoment: d ? this.$moment(d + ' ' + this.$moment().format('HH:mm')) : null,
      };
      this.editDialog = true;
    },
    openEditDialog(data) {
      var calEvent = data.item;

      this.editData = {
        calEvent: calEvent,
        members: data.members,
        targetMoment: null,
      };
      this.editDialog = true;
    },
  },
};
</script>

<style scoped>
.container {
  padding: 10px;
  min-height: calc(100vh - 200px);
}
.le-tbs .container {
  min-height: calc(100vh - 109px);
}
</style>
